import { ActionIcon } from '@mantine/core';
import { IconEyeOff, IconEyeCheck, IconArrowBackUp, IconBallpen } from '@tabler/icons';
import { FC, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { EmailBoxContext } from '../../Service/Context/EmailBoxContext';
import { MessageS } from '../../Service/MessageS';
import { folderActionIconSx } from './EmailFolderActions';

interface Props {
  phoneVersion: boolean;
}

const EmailActions: FC<Props> = ({ phoneVersion }) => {
  const { box } = useParams();
  const { selectedMessage, selectMessage, prepareMessage, changeEmail } = useContext(EmailBoxContext);

  if (!selectedMessage) return null;

  const markAsReadHandler = async (read: boolean) => {
    if (selectedMessage) {
      const patchedEmail = await MessageS.patchEmail(selectedMessage.id, { read });
      if (patchedEmail) {
        changeEmail(patchedEmail);
        selectMessage(patchedEmail);
      }
    }
  };

  return (
    <>
      {selectedMessage.readTimestamp && phoneVersion && box === 'inbox' && (
        <ActionIcon size="sm" sx={folderActionIconSx} onClick={() => markAsReadHandler(false)}>
          <IconEyeOff />
        </ActionIcon>
      )}
      {!selectedMessage.readTimestamp && phoneVersion && box === 'inbox' && (
        <ActionIcon size="sm" sx={folderActionIconSx} onClick={() => markAsReadHandler(true)}>
          <IconEyeCheck />
        </ActionIcon>
      )}
      {phoneVersion && box === 'inbox' && (
        <ActionIcon size="sm" sx={folderActionIconSx} onClick={() => prepareMessage('REPLY')}>
          <IconArrowBackUp />
        </ActionIcon>
      )}
      {phoneVersion && box === 'drafts' && (
        <ActionIcon size="sm" sx={folderActionIconSx} onClick={() => prepareMessage('EDIT')}>
          <IconBallpen />
        </ActionIcon>
      )}
    </>
  );
};

export default EmailActions;
